/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-new-plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<rect pid="0" x="7.048" y="2" width="1.281" height="12" rx=".641" _fill="#566473"/><rect pid="1" x="1.922" y="8.667" width="1.333" height="11.533" rx=".667" transform="rotate(-90 1.922 8.667)" _fill="#566473"/>'
  }
})
